import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import ExpressCheckout from '../../../components/NextGen/ExpressCheckout/index';

import { withSaga, withReducer, withConnect } from '../common';

export default withRouter(
    compose(
        withSaga,
        withReducer,
        withConnect,
    )(ExpressCheckout),
);
